import React from 'react';

import DateField from 'components/formInputs/DateField';
import RadioGroupField from 'components/formInputs/RadioGroupField';
import TextField from 'components/formInputs/TextField';
import ToggleField from 'components/formInputs/ToggleField';
import FormWrapper from 'components/FormWrapper';
import ShowHide from 'components/ShowHide';
import { parseInteger } from 'forms/parsers';

import { LABELS, SEVERITIES } from './constants';
import { SleepApneaFormProps } from './types';

const SleepApneaForm: React.FC<SleepApneaFormProps> = ({
  handleSubmit,
  invalid,
  submitting,
  values,
}) => (
  <FormWrapper handleSubmit={handleSubmit} invalid={invalid} submitting={submitting}>
    <DateField label={LABELS.diagnosedAt} name="diagnosedAt" />
    <RadioGroupField groupLabel={LABELS.severity} name="severity" options={SEVERITIES} />
    <ToggleField groupLabel={LABELS.everTreated} name="everTreated" />
    <ShowHide visible={values.everTreated}>
      <DateField label={LABELS.treatedAt} name="treatedAt" />
      <ToggleField groupLabel={LABELS.usesCPAPMachine} name="usesCPAPMachine" />
    </ShowHide>
    <ToggleField groupLabel={LABELS.sleepStudyConducted} name="sleepStudyConducted" />
    <ShowHide visible={values.sleepStudyConducted}>
      <DateField label={LABELS.sleepStudyConductedAt} name="sleepStudyConductedAt" />
      <TextField
        config={{ parse: parseInteger }}
        inputMode="numeric"
        label={LABELS.oxygenSaturation}
        name="oxygenSaturation"
        suffix="%"
      />
      <TextField
        config={{ parse: parseInteger }}
        helperText="Number of events per hour of sleep"
        inputMode="numeric"
        label={LABELS.apneaIndex}
        name="apneaIndex"
      />
      <TextField
        config={{ parse: parseInteger }}
        helperText="Number of AHI events per hour of sleep"
        inputMode="numeric"
        label={LABELS.apneaHypopneaIndex}
        name="apneaHypopneaIndex"
      />
      <TextField
        config={{ parse: parseInteger }}
        helperText="Number of RDI events per hour of sleep"
        inputMode="numeric"
        label={LABELS.respiratoryDisturbanceIndex}
        name="respiratoryDisturbanceIndex"
      />
    </ShowHide>
  </FormWrapper>
);

export default SleepApneaForm;
